import React, { useContext, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MessageContext from '../../App/Contexts/MessageContext';

const tabSx = (theme) => ({
    width: '100%',
    height: 0,
    position: 'absolute',
    bottom: 0,
    left: 0,
    transition: 'all 0.5s',
    color: 'rgba(0,0,0,0)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    margin: 'unset',
    paddingTop: '12px',
    cursor: 'text',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.typography.subtitle1
});

// Menu should contain objects like: { displayText: 'delete', callback: () => { ... } }
function CardTabSlide({ text, dark, menu = [] }) {
    const { setMessage } = useContext(MessageContext);
    const menuParentRef = useRef();
    const [menuOpen, setMenuOpen] = useState(false);

    const options = menu.map(({ displayText }) => displayText);

    // Function to copy text to clipboard
    function onTabClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.target.textContent === text) {
            navigator.clipboard.writeText(event.target.textContent);
            setMessage('Copied to clipboard: ' + event.target.textContent);
        }
    }

    function onMenuOptionClick(event, displayText) {
        event.stopPropagation();
        event.preventDefault();
        const selection = menu.find((option) => option.displayText === displayText);
        setMenuOpen(false);
        selection.callback();
    }

    return (
        <span>
            <Box
                component='dd'
                sx={(theme) =>
                    dark
                        ? {
                              ...tabSx(theme),
                              background: theme.palette.primary.main,
                              color: theme.palette.primary.contrastText
                          }
                        : {
                              ...tabSx(theme),
                              background: theme.palette.secondary.main,
                              color: theme.palette.secondary.contrastText
                          }
                }
                onClick={onTabClick}>
                <span style={{ width: '100%', textAlign: 'center' }}>{text}</span>
                {menu.length ? (
                    <>
                        <IconButton
                            style={{ padding: 0, outline: 0 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setMenuOpen(true);
                            }}
                            ref={menuParentRef}>
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id='long-menu'
                            anchorEl={menuParentRef.current}
                            keepMounted
                            open={menuOpen}
                            onClose={() => setMenuOpen(false)}>
                            {options.map((displayText) => (
                                <MenuItem
                                    key={displayText}
                                    onClick={(event) => onMenuOptionClick(event, displayText)}>
                                    {displayText}
                                </MenuItem>
                            ))}
                        </Menu>
                    </>
                ) : null}
            </Box>
        </span>
    );
}

export default CardTabSlide;
